import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl =
  "/merchflows/:merchflowId/stores/:storeCode/original-psa/download-url";

export type ParamsGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl =
  ExtractRouteParams<typeof RouteGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl>;

export interface ResponseGetMerchflows_MerchflowId_Stores_StoreCode_OriginalPsaDownloadUrl {
  url: string;
}
